import { CdkMenuTrigger } from '@angular/cdk/menu';
import type { AfterContentInit, QueryList } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { DropdownItemDirective } from './dropdown-menu.directive';

@Component({
  selector: 'palantir-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PalantirDropdownMenuComponent implements AfterContentInit {
  @ContentChildren(DropdownItemDirective)
  public options?: QueryList<DropdownItemDirective>;

  @ViewChild(CdkMenuTrigger)
  public trigger?: CdkMenuTrigger;

  @Output() public selected = new EventEmitter<any>();

  @Input({ required: true }) public label!: string;

  @Input() public value?: string;

  public selectedValue = signal<string | null>(null);

  public ngAfterContentInit(): void {
    if (!this.options) {
      return;
    }

    const itemSelected = this.value ? this.options.find((item) => item.value === this.value) : null;

    const firstItem = this.options.first;

    const initialSelectedItem = itemSelected ?? firstItem;

    this.selectedValue.set(initialSelectedItem?.elementRef.nativeElement.textContent);

    this.toggleSelected(initialSelectedItem);

    for (const option of this.options) {
      const nativeElement = option.elementRef.nativeElement;

      nativeElement.addEventListener('click', () => {
        const text = nativeElement.textContent;

        this.selectedValue.set(text);
        this.toggleSelected(option);

        this.trigger?.close();
        this.selected.emit(option.value);
      });
    }
  }

  private toggleSelected(option: DropdownItemDirective): void {
    for (const item of this.options ?? []) {
      item.elementRef.nativeElement.classList.remove('selected');
    }

    option.elementRef.nativeElement.classList.add('selected');
  }
}
